
import Model from '@app/Model'

export class BasePicturesModel extends Model {
	static fields () {
		return {
			id: null,
			pictures: null
		}
	}

	get picturesV2 () {
		const imageSizes = [
			'105/70', '570/380', '195/130', '360/240', '1050/700', '1920/1080'
		]
		if (this.pictures?.length) {

			return this.pictures.map(picture => {
				if (picture?.fullUrl) {
					return {
						...picture,
						original: picture.fullUrl,
						optimized: picture.fullUrl,
						thumbnail: picture.fullUrl,
						...imageSizes.reduce((acc, size) => {
							acc[`s${size.replace('/', 'x')}`] = picture.fullUrl
							return acc
						}, {})
					}
				}
				return {
					...picture,
					original: `${picture.host}0/0/${picture.url}`,
					optimized: `${picture.host}1920/1080/${picture.url}`,
					thumbnail: `${picture.host}200/200/${picture.url}`,
					...imageSizes.reduce((acc, size) => {
						acc[`s${size.replace('/', 'x')}`] = `${picture.host}${size}/${picture.url}`
						return acc
					}, {})
				}
			})
		}
		return []
	}

}
export function createSubpart (data) {
	return Object.freeze(new BasePicturesModel(data))
}
